var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"NotFound"},[_c('p',[_vm._v("Aradağınız sayfa bulunamadı")]),_c('router-link',{staticClass:"button button__red",attrs:{"to":"/"}},[_vm._v("Anasayfa Dön")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }